import React, { useMemo } from 'react';
import { t } from 'Locale';
import VoyoButton from 'LocalGluons/components/VoyoButton';
// eslint-disable-next-line import/no-cycle
import iconMap from 'LocalGluons/components/Icon/iconMap';
import { PLATFORMS } from 'Options';
import getVoyoBadgeParameters from './getVoyoBadgeParameters';
import defaultStyles from './styles';
import { SUBSCRPTION_TYPE } from '../../../PackageInfoScene/getVoyoPackageTexts';
import { DefaultBadgeButton } from './DefaultBadgeButton/DefaultBadgeButton';

export interface Playouts {
    packageId: number;
    logoUrl: string;
    packageNameString: string;
    packageDescriptionString: string;
    playoutsMaxCount: number | null;
    playoutsActualCount: number | null;
    renewalDate: string | null;
    type: string;
    consent: boolean;
}
interface BadgeButtonProops {
    platform: string;
    onPress: () => void;
    playouts: Playouts;
}

const BadgeButton = ({ onPress, playouts, platform }: BadgeButtonProops): JSX.Element => {
    const { fill, showProgress, progressComponent, showWarningColor } = useMemo(
        () => getVoyoBadgeParameters(playouts, playouts?.type as SUBSCRPTION_TYPE),
        [playouts]);

    let title: string;

    switch (platform) {
        case PLATFORMS.VOYO: {
            const hasConsent = playouts?.consent;

            return (
                <VoyoButton
                    style={{
                        button: defaultStyles.button,
                        text: defaultStyles.text
                    }}
                    isSecondary
                    iconSource={{ uri: playouts?.logoUrl }}
                    title={t(playouts?.packageDescriptionString)}
                    secondaryTitle={t(playouts?.packageDescriptionString)}
                    fill={fill}
                    showProgress={hasConsent && showProgress}
                    onPress={onPress}
                    progressInnerComponent={progressComponent}
                    showWarningColor={showWarningColor}
                />);
        }
        case PLATFORMS.CANALPLUS:
            title = 'PARTNER.CANALPLUS.INFO_ABOUT_SERVICE_MOBILES';
            break;
        default:
            title = playouts?.packageDescriptionString;
    }

    return (
        <DefaultBadgeButton
            style={{
                button: defaultStyles.button,
                text: defaultStyles.text,
            }}
            iconSource={playouts?.logoUrl ? { uri: playouts?.logoUrl } : iconMap.info_circle_filled}
            title={t(title)}
            onPress={onPress}
        />
    );
};

export default BadgeButton;
